import React from 'react';
import { Scissors, Star, Crown, User, Instagram, Calendar, Award, Clock } from 'lucide-react';
const GOLD = '#C9A84C';
const DARK_BG = '#0D0D0D';
const CARD_BG = '#1A1A1A';
const BOOKING_URL = 'https://mihairstudioo.site.agendapro.com/uy';
export function App() {
  return <div className="min-h-screen text-white selection:bg-[#C9A84C] selection:text-black overflow-x-hidden" style={{
    backgroundColor: DARK_BG
  }} data-id="element-0">
      {/* 1. HERO BANNER */}
      <section className="w-full" data-id="element-1">
        <img src="https://cdn.magicpatterns.com/uploads/2aMGei7E5PR8wyrPnvCwUR/Banner_original.png" alt="Mi Hair Studio Banner" className="w-full h-auto" data-id="element-2" />
      </section>

      {/* 1.5 HERO TEXT */}
      <section className="pt-16 pb-20 px-4 text-center max-w-4xl mx-auto flex flex-col items-center" data-id="element-3">
        <div className="inline-block mb-4 px-4 py-1 border border-[#C9A84C] rounded-full text-[#C9A84C] text-sm font-medium tracking-widest uppercase" data-id="element-4">
          Uruguay
        </div>
        <h1 className="text-5xl md:text-7xl font-bold mb-6 tracking-tight leading-tight" data-id="element-5">
          El Corte Que <br data-id="element-6" />
          <span style={{
          color: GOLD
        }} data-id="element-7">
            Te Define
          </span>
        </h1>
        <p className="text-lg md:text-xl text-gray-300 mb-10 font-light tracking-wide" data-id="element-8">
          Professional Barber UY • +10 años de experiencia • Since 2016
        </p>
        <a href={BOOKING_URL} target="_blank" rel="noopener noreferrer" className="group relative inline-flex items-center justify-center px-8 py-4 font-bold text-black transition-all duration-300 bg-[#C9A84C] rounded-full hover:bg-white hover:scale-105" data-id="element-9">
          AGENDÁ TU TURNO
          <Calendar className="ml-2 w-5 h-5 group-hover:rotate-12 transition-transform" data-id="element-10" />
        </a>
      </section>

      {/* 2. SOCIAL PROOF BAR */}
      <section className="border-y border-zinc-800/50" style={{
      backgroundColor: CARD_BG
    }} data-id="element-11">
        <div className="max-w-6xl mx-auto px-4 py-8" data-id="element-12">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 text-center divide-y md:divide-y-0 md:divide-x divide-zinc-800" data-id="element-13">
            <div className="flex flex-col items-center justify-center pt-4 md:pt-0" data-id="element-14">
              <Instagram style={{
              color: GOLD
            }} className="w-8 h-8 mb-3" data-id="element-15" />
              <span className="text-2xl font-bold" data-id="element-16">6,155+</span>
              <span className="text-sm text-gray-400 uppercase tracking-wider mt-1" data-id="element-17">
                Seguidores en Instagram
              </span>
            </div>
            <div className="flex flex-col items-center justify-center pt-8 md:pt-0" data-id="element-18">
              <Award style={{
              color: GOLD
            }} className="w-8 h-8 mb-3" data-id="element-19" />
              <span className="text-2xl font-bold" data-id="element-20">+10 Años</span>
              <span className="text-sm text-gray-400 uppercase tracking-wider mt-1" data-id="element-21">
                De Experiencia
              </span>
            </div>
            <div className="flex flex-col items-center justify-center pt-8 md:pt-0" data-id="element-22">
              <Clock style={{
              color: GOLD
            }} className="w-8 h-8 mb-3" data-id="element-23" />
              <span className="text-2xl font-bold" data-id="element-24">Desde 2016</span>
              <span className="text-sm text-gray-400 uppercase tracking-wider mt-1" data-id="element-25">
                Marcando Tendencia
              </span>
            </div>
          </div>
        </div>
      </section>

      {/* 3. SERVICES SECTION */}
      <section className="py-24 px-4 max-w-6xl mx-auto" data-id="element-26">
        <div className="text-center mb-16" data-id="element-27">
          <h2 className="text-3xl md:text-5xl font-bold mb-4" data-id="element-28">
            Nuestros{' '}
            <span style={{
            color: GOLD
          }} data-id="element-29">
              Servicios
            </span>
          </h2>
          <div className="w-24 h-1 mx-auto" style={{
          backgroundColor: GOLD
        }} data-id="element-30"></div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-31">
          {[{
          icon: Scissors,
          title: 'Cortes de Cabello',
          desc: 'Diseños clásicos y modernos adaptados a tu fisonomía.'
        }, {
          icon: Crown,
          title: 'Servicio VIP',
          desc: 'Atención exclusiva con productos de primera línea.'
        }, {
          icon: Star,
          title: 'Experiencia Premium',
          desc: 'Más que un corte, un momento de relajación total.'
        }, {
          icon: User,
          title: 'Estilo Personalizado',
          desc: 'Asesoramiento de imagen para encontrar tu mejor versión.'
        }].map((service, idx) => <div key={idx} className="p-8 rounded-2xl transition-all duration-300 hover:-translate-y-2 border border-zinc-800 hover:border-[#C9A84C]/50 group" style={{
          backgroundColor: CARD_BG
        }} data-id="element-32">
              <div className="w-14 h-14 rounded-full flex items-center justify-center mb-6 bg-black/50 group-hover:bg-[#C9A84C]/10 transition-colors" data-id="element-33">
                <service.icon style={{
              color: GOLD
            }} className="w-7 h-7" data-id="element-34" />
              </div>
              <h3 className="text-xl font-bold mb-3" data-id="element-35">{service.title}</h3>
              <p className="text-gray-400 leading-relaxed" data-id="element-36">{service.desc}</p>
            </div>)}
        </div>
      </section>

      {/* 4. ABOUT / TRUST SECTION (with Video) */}
      <section className="py-24 px-4" style={{
      backgroundColor: CARD_BG
    }} data-id="element-37">
        <div className="max-w-6xl mx-auto grid lg:grid-cols-2 gap-16 items-center" data-id="element-38">
          <div className="order-2 lg:order-1" data-id="element-39">
            <h2 className="text-3xl md:text-5xl font-bold mb-6 leading-tight" data-id="element-40">
              Más de 10 Años Dando{' '}
              <span style={{
              color: GOLD
            }} data-id="element-41">
                Forma a Tu Estilo
              </span>
            </h2>
            <p className="text-gray-300 text-lg leading-relaxed mb-8" data-id="element-42">
              En Mi Hair Studio, no solo cortamos el cabello; esculpimos tu
              identidad. Nacidos en Uruguay con una pasión inquebrantable por el
              arte de la barbería, combinamos técnicas tradicionales con las
              últimas tendencias urbanas. Nuestro compromiso es brindarte una
              experiencia premium donde cada detalle cuenta, asegurando que
              salgas por nuestra puerta luciendo y sintiéndote como tu mejor
              versión.
            </p>
            <div className="flex items-center gap-4" data-id="element-43">
              <div className="w-12 h-12 rounded-full flex items-center justify-center border border-[#C9A84C]" data-id="element-44">
                <Scissors style={{
                color: GOLD
              }} className="w-5 h-5" data-id="element-45" />
              </div>
              <div data-id="element-46">
                <p className="font-bold text-lg" data-id="element-47">Mateo Rodriguez</p>
                <p className="text-[#C9A84C] text-sm uppercase tracking-wider" data-id="element-48">
                  Master Barber
                </p>
              </div>
            </div>
          </div>

          <div className="order-1 lg:order-2 relative" data-id="element-49">
            <div className="absolute -inset-4 border border-[#C9A84C]/30 rounded-3xl translate-x-4 translate-y-4 -z-10" data-id="element-50"></div>
            <div className="rounded-2xl overflow-hidden shadow-2xl shadow-black/50 aspect-[4/5] relative bg-zinc-900" data-id="element-51">
              <video src="https://cdn.magicpatterns.com/uploads/hdekUV5nz7Zdecfmb8CvRm/Diseño sin título.mp4" autoPlay loop muted playsInline className="w-full h-full object-cover" data-id="element-52" />
              {/* Subtle overlay to ensure it blends well with dark theme */}
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent" data-id="element-53"></div>
            </div>
          </div>
        </div>
      </section>

      {/* 5. INSTAGRAM GALLERY STRIP */}
      <section className="py-24 px-4 max-w-6xl mx-auto" data-id="element-54">
        <div className="text-center mb-12" data-id="element-55">
          <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-56">
            Nuestro Trabajo{' '}
            <span style={{
            color: GOLD
          }} data-id="element-57">
              Habla Solo
            </span>
          </h2>
          <a href="https://instagram.com/mateoorodriguez_12" target="_blank" rel="noopener noreferrer" className="inline-flex items-center text-gray-400 hover:text-[#C9A84C] transition-colors" data-id="element-58">
            <Instagram className="w-4 h-4 mr-2" data-id="element-59" />
            @mateoorodriguez_12
          </a>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-60">
          {['https://cdn.magicpatterns.com/uploads/af2iwrVbTVffbZM8MGAwin/igsnapinsta.com-www.instagram.com-p-DHTlpS6MKnJ-.jpg', 'https://cdn.magicpatterns.com/uploads/jBnJ4Qo9uEVqKJNt3uTzMn/igsnapinsta.com-www.instagram.com-p-DMX2Xz7MBNR-.jpg', 'https://cdn.magicpatterns.com/uploads/3ik91YZUV8SZPnp57ynnPU/igsnapinsta.com-www.instagram.com-p-DYaSsS2RV3B-.jpg'].map((img, idx) => <div key={idx} className="group relative aspect-square rounded-2xl overflow-hidden bg-zinc-900" data-id="element-61">
              <img src={img} alt={`Client ${idx + 1}`} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" data-id="element-62" />
              <div className="absolute inset-0 bg-black/40 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center" data-id="element-63">
                <Instagram className="w-10 h-10 text-white" data-id="element-64" />
              </div>
            </div>)}
        </div>
      </section>

      {/* 6. CTA SECTION */}
      <section className="relative py-32 px-4 text-center overflow-hidden" data-id="element-65">
        <div className="absolute inset-0 bg-[#C9A84C]/10" data-id="element-66"></div>
        <div className="absolute inset-0 bg-gradient-to-b from-[#0D0D0D] via-transparent to-[#0D0D0D]" data-id="element-67"></div>

        <div className="relative z-10 max-w-3xl mx-auto" data-id="element-68">
          <h2 className="text-4xl md:text-6xl font-bold mb-8" data-id="element-69">
            ¿Listo Para Tu <br data-id="element-70" />
            <span style={{
            color: GOLD
          }} data-id="element-71">
              Próximo Corte?
            </span>
          </h2>
          <p className="text-xl text-gray-300 mb-10" data-id="element-72">
            Asegurá tu lugar y viví la experiencia premium que merecés.
          </p>
          <a href={BOOKING_URL} target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center px-10 py-5 text-lg font-bold text-black transition-all duration-300 bg-[#C9A84C] rounded-full hover:bg-white hover:shadow-[0_0_40px_rgba(201,168,76,0.4)] hover:-translate-y-1" data-id="element-73">
            RESERVÁ AHORA — Es Gratis
          </a>
        </div>
      </section>

      {/* 7. FOOTER */}
      <footer className="border-t border-zinc-800 pt-16 pb-8 px-4" style={{
      backgroundColor: CARD_BG
    }} data-id="element-74">
        <div className="max-w-6xl mx-auto flex flex-col items-center text-center" data-id="element-75">
          <h3 className="text-2xl font-bold tracking-widest uppercase mb-6" style={{
          color: GOLD
        }} data-id="element-76">
            Mi Hair Studio
          </h3>

          <a href="https://instagram.com/mateoorodriguez_12" target="_blank" rel="noopener noreferrer" className="w-12 h-12 rounded-full bg-zinc-900 flex items-center justify-center text-gray-400 hover:text-[#C9A84C] hover:bg-black transition-all mb-8" data-id="element-77">
            <Instagram className="w-5 h-5" data-id="element-78" />
          </a>

          <p className="text-gray-500 text-sm tracking-widest uppercase" data-id="element-79">
            Professional Barber UY • Since 2016
          </p>
          <p className="text-zinc-700 text-xs mt-4" data-id="element-80">
            © {new Date().getFullYear()} Mi Hair Studio. Todos los derechos
            reservados.
          </p>
        </div>
      </footer>
    </div>;
}